import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Tooltip, UserLevelProgress } from '@ds'
import { usePrologue } from '@store'

import styles from './Tooltip.module.scss'

const SHOW_TOOLTIP_TIME = 4000

export const TooltipUserLevel = () => {
  const [showUserLevelTooltip, setShowUserLevelTooltip] = useState(false)

  const { showTooltips } = usePrologue()
  const { t } = useTranslation()

  useEffect(() => {
    if (showTooltips) {
      setShowUserLevelTooltip(true)
      const timeout = setTimeout(
        () => setShowUserLevelTooltip(false),
        SHOW_TOOLTIP_TIME
      )

      return () => clearTimeout(timeout)
    }
  }, [showTooltips])

  return (
    <>
      <Tooltip
        tooltipId="quest-user-level-tooltip"
        isOpen={showUserLevelTooltip}
        position="bottom"
        tooltipContent={
          <div className={styles.tooltipFont}>
            <div className={styles.tooltipFont}>
              {t('prologue.userLevelTooltip')}
            </div>
          </div>
        }
      >
        <UserLevelProgress />
      </Tooltip>
    </>
  )
}
